import * as React from "react";
import styled from "styled-components";
import {
  ArrowChevronRight,
  spacing,
  Checkbox,
  ActionItemButton,
} from "@conserveit/blocks";
import { RuleSetting } from "../../../context/settings/types";

const StyledActionItem = styled(ActionItemButton)`
  display: inline-flex;
  ${ArrowChevronRight} {
    visibility: hidden;
  }
  &:hover {
    ${ArrowChevronRight} {
      visibility: visible;
    }
  }
`;

const RuleText = styled.span`
  margin-left: ${spacing.tight};
`;

const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  label {
    margin-bottom: 0;
  }
`;

type Props = {
  rule: RuleSetting;
  isActive: boolean;
  isChecked: boolean;
  onRuleSelect(rule: RuleSetting): void;
  onRuleChecked(rule: RuleSetting): () => void;
};

const RuleItem = React.memo(
  ({ isActive, rule, onRuleSelect, onRuleChecked, isChecked }: Props) => {
    return (
      <StyledActionItem
        isActive={isActive}
        iconRight={<ArrowChevronRight tiny />}
        onClick={() => onRuleSelect(rule)}
      >
        <Item>
          <Checkbox
            name="RuleCheckbox"
            value=""
            checked={isChecked}
            onChange={onRuleChecked(rule)}
          />
          <RuleText>{rule.rule.name}</RuleText>
        </Item>
      </StyledActionItem>
    );
  },
  (p, n) => p.isChecked === n.isChecked && p.isActive === n.isActive
);

export { RuleItem };
